import apiClient from './apiClient'
import { getToken } from '../utils/localStorage'

class NotificationsAPI {
  static token = getToken(); // Make token static

  static getUserList(q, page, limit = 20) {
    return apiClient
      .get(`/notification/user-list/?q=${q}&page=${page}&limit=${limit}&sort=-createdAt`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.token}`,
        },
      })
      .then(({ data }) => data.data)
  }

  static sendNotification(payload) {
    return apiClient
      .post(`/notification/send-notification/`,payload, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.token}`,
        },
      })
      .then(({ data }) => data.data)
  }

  static getNotificartions(q, page, limit = 20) {
    return apiClient
      .get(`/notification/?q=${q}&page=${page}&limit=${limit}&sort=-createdAt`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.token}`,
        },
      })
      .then(({ data }) => data.data)
  }
}

export default NotificationsAPI
